import React, {useState} from 'react'
import {Box, Chip, Divider, Popover, Stack, Typography} from '@mui/material'
import BoltRoundedIcon from '@mui/icons-material/BoltRounded'
import {useTranslation} from 'react-i18next'
import {useCurrentRateQuery} from 'store/Store'
import {getUnit} from 'components/Page/Dashboard/dashboardFormat'

// The tariff in force right now is reference info, so it lives as a chip instead of a card.
const RateChip = ({category}) => {
    const {t} = useTranslation()
    const {data: rates} = useCurrentRateQuery()
    const [anchor, setAnchor] = useState(null)

    const current = (rates || []).filter((rate) => !rate.category || rate.category === category)
    if (!current.length) return null

    const unit = getUnit(category)
    const [first] = current

    return (
        <>
            <Chip
                icon={<BoltRoundedIcon />}
                label={
                    <>
                        {t('dashboard.rate.now')}:{' '}
                        <bdi>
                            {Number(first.rate).toFixed(2)} ₪{unit ? `/${unit}` : ''}
                        </bdi>
                    </>
                }
                onClick={(event) => setAnchor(event.currentTarget)}
                variant="outlined"
                color="primary"
            />
            <Popover
                open={Boolean(anchor)}
                anchorEl={anchor}
                onClose={() => setAnchor(null)}
                anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}>
                <Box sx={{p: 2, minWidth: 260}}>
                    <Typography variant="subtitle2" fontWeight={700} sx={{mb: 1}}>
                        {t('dashboard.rate.title')}
                    </Typography>
                    {current.map((rate, index) => (
                        <React.Fragment key={rate._id || `${rate.name}-${rate.typeDay}`}>
                            {index > 0 && <Divider sx={{my: 1}} />}
                            <Stack direction="row" justifyContent="space-between" spacing={3}>
                                <Typography variant="body2">
                                    {[rate.name, rate.typeDay]
                                        .filter(Boolean)
                                        .map((key) => t(`selectOptions.${key}`))
                                        .join(' · ')}
                                </Typography>
                                <Typography variant="body2" fontWeight={700}>
                                    <bdi>
                                        {Number(rate.rate).toFixed(3)} ₪{unit ? `/${unit}` : ''}
                                    </bdi>
                                </Typography>
                            </Stack>
                        </React.Fragment>
                    ))}
                </Box>
            </Popover>
        </>
    )
}

export default RateChip
